import type { ErrorType } from './events';

export function errorTypeOf(error: unknown): ErrorType {
  const status = (error as { status?: unknown } | null | undefined)?.status;

  if (status === 'FETCH_ERROR') return 'network';
  if (status === 'TIMEOUT_ERROR') return 'timeout';
  if (status === 'PARSING_ERROR') return 'server';

  if (typeof status === 'number') {
    if (status === 408 || status === 504) return 'timeout';
    if (status === 401 || status === 403) return 'auth';
    if (status === 400 || status === 422) return 'validation';
    if (status >= 500) return 'server';
  }

  if (error instanceof TypeError) return 'network';

  return 'unknown';
}
